import { ConnectionStatus } from "./ConnectionStatus";

const CONFIG = {
  active: { tone: "success", label: "IA no ar" },
  paused: { tone: "warning", label: "IA pausada" },
  unavailable: { tone: "danger", label: "IA indisponível" },
} as const;

export type AiState = keyof typeof CONFIG;

/**
 * Indicador de estado da IA (WhatsApp), no vocabulário de cor do design
 * system: verde = ativa, âmbar = pausada, vermelho = indisponível. Nasce do
 * pill "IA no ar" hoje fixo em `layouts/Topbar.tsx` (`bg-success-weak` +
 * ponto verde, sempre no estado ativo — o Shell não liga a nenhum dado
 * real). Este componente só formaliza a apresentação; **não introduz
 * estado dinâmico**: a API do EVENT AI não expõe hoje um endpoint de
 * "IA pausada/indisponível" para o painel consumir. `state` tem default
 * `"active"` para reproduzir o comportamento atual — quando existir uma
 * fonte de dado real, quem consome troca a prop, sem mudar este
 * componente.
 */
export function AiStatus({ state = "active", className }: { state?: AiState; className?: string }) {
  const { tone, label } = CONFIG[state];
  return (
    <ConnectionStatus tone={tone} className={className}>
      {label}
    </ConnectionStatus>
  );
}
